import React from 'react';
import Layout from "./components/Layout";
import Hero from './components/Hero';
import './scss/main.scss';

function App() {
    return (
        <Layout>
            <Hero />
        </Layout>
    );
}

export default App;
